
import { format } from 'date-fns';

class ApiSender {
    constructor() {
    }

    async getMsisdnFromHeader() {
        const baseUrl = process.env.REACT_APP_GTW_BASE_URL;

        try {
            const response = await fetch(`${baseUrl}game/access`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const result = await response.json();

            const accessRsp = result.data;
            if (!accessRsp) {
                return {
                    success: false,
                    msisdn: null,
                    message: result.message || "No description available"
                };
            }

            const heUrl = process.env.REACT_APP_HE_URL;
            const checkHeader = await fetch(`${heUrl}`, {
                method: 'GET',
                headers: {
                    "content-type": "application/json", "authorization": `Bearer ${accessRsp}`, "x-source-system": "he-partner"
                },
            });

            if (!checkHeader.ok) {
                throw new Error(`HTTP error! Status: ${checkHeader.status}`);
            }

            const resultCheckHeader = await checkHeader.json();

            return {
                success: true,
                msisdn: resultCheckHeader?.ServiceResponse?.ResponseBody?.Response?.Msisdn || null,
                message: resultCheckHeader?.ServiceResponse?.ResponseHeader?.ResponseMsg || "No description available"
            };

        } catch (error) {
            console.error("Error fetching MSISDN from header:", error);

            return {
                success: false,
                msisdn: null,
                message: "Error fetching MSISDN from header",
            };
        }
    }

    async heSubscribe(msisdn, heId, goalId, goalName, landingPageUrl, landingPageName, paramsObject) {
        const date = new Date();
        const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
        const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
        const payload = {
            msisdn,
            campaignId: paramsObject.campaignId || null,
            affiliateTrackerId: paramsObject.trackerId || null,
            language: 'EN',
            heId,
            gclid: paramsObject.gclid || null,
            gbraid: paramsObject.gbraid || null,
            wbraid: paramsObject.wbraid || null,
            conversionDateTime: formattedDateTime,
            conversionGoalId: goalId,
            conversionGoalName: goalName,
            landingPageUrl,
            landingPageName,
            ...Object.fromEntries(
                Array.from({ length: 15 }, (_, i) => [`p${i + 1}`, paramsObject[`p${i + 1}`] || null])
            )
        };

        try {
            const response = await fetch(`${baseUrl}game/subscribe`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    message: result.code !== 5000
                        ? result.message
                        : 'Error Happened'
                };
            }

            return {
                success: result.status || false,
                message: result.message || ('No description available'),
                url: result.data
            };
        } catch (error) {
            console.error("Error subscribing user over HE:", error.message);

            return {
                success: false,
                message: 'Error Happened'
            };
        }
    }

    async heFoSubscribe(msisdn, paramsObject) {
        const baseUrl = process.env.REACT_APP_GTW_BASE_URL;

        try {
            const campaignId = paramsObject.campaignId;
            if (campaignId === null || campaignId === undefined) {
                return {
                    success: false,
                    code: null,
                    message: 'Campaign Not Provided'
                };
            }

            const response = await fetch(`${baseUrl}game/campaign`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    msisdn,
                    campaignId: campaignId,
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    code: null,
                    message: result.code !== 5000
                        ? result.message
                        : 'Error Happened'
                };
            }

            return {
                success: result?.status ?? false,
                code: result.code,
                message: result?.status
                    ? ''
                    : 'Subscription failed'
            };
        } catch (error) {
            console.error("Error in force subscription over HE:", error.message);

            return {
                success: false,
                code: null,
                message: 'Error Happened'
            };
        }
    }

    async playGame(token) {
        const baseUrl = process.env.REACT_APP_GTW_BASE_URL;

        try {
            if (token === null || token === undefined) {
                return {
                    success: false,
                    code: null,
                    message: 'Token Not Provided'
                };
            }

            const response = await fetch(`${baseUrl}game/play`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    token
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                return {
                    success: false,
                    code: result.code,
                    message: result.code !== 5000
                        ? result.message
                        : 'Error Happened'
                };
            }

            return {
                success: result?.status ?? false,
                code: result.code,
                userId: result.userId,
                token: result.token,
                message: result?.status
                    ? ''
                    : 'Play Game Failed'
            };
        } catch (error) {
            console.error("Error in play game:", error.message);

            return {
                success: false,
                code: null,
                message: 'Error Happened'
            };
        }
    }

    async sendLogs(page, params) {
        const baseUrl = process.env.REACT_APP_GTW_BASE_URL;
        try {
            await fetch(`${baseUrl}game/logs?page=${page}&${params}`, {
                method: 'GET',
                headers: { "Content-Type": "application/json" },
            });
        } catch (error) {
            console.error("Error in send logs:", error.message);
        }
    }

    async saveHistory(landingPageUrl, paramsObject) {
        try {
            const isGoogleCampaign = paramsObject?.hasOwnProperty("gclid");
            if (!isGoogleCampaign) return;

            const baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
            const endpoint = "google/visit";
            const allowedKeys = [
                "gclid", "gbraid", "wbraid", "campaignId", "conversions", "cost_micros", "cpa", "utm_source",
                "utm_medium", "utm_campaign", "utm_term", "utm_content", "ad_group_id", "ad_group_name",
                "ad_id", "keyword_id", "keyword_text", "match_type", "clicks", "impressions", "ctr",
                "average_cpc", "conversion_date", "click_date", "geo_location", "device"
            ];

            const extraParams = Object.fromEntries(
                Object.entries(paramsObject).filter(([key]) => !allowedKeys.includes(key))
            );

            const payload = {
                ...allowedKeys.reduce((acc, key) => {
                    acc[this.camelCase(key)] = paramsObject[key];
                    return acc;
                }, {}),
                landingPageUrl,
                extraParams: JSON.stringify(extraParams),
            };

            await fetch(`${baseUrl}${endpoint}`, {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
        } catch (error) {
            console.error("Error in google saveHistory:", error.message);
        }
    }

    async getGoalsInfo(paramsObject) {
        const baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;

        try {
            const campaignId = paramsObject.campaignId;
            if (campaignId === null || campaignId === undefined) {
                return {
                    success: false,
                    message: 'Campaign Not Found',
                    goalId: null,
                    goalName: null
                };
            }

            const response = await fetch(`${baseUrl}campaign/info?uuid=${campaignId}`, {
                method: 'GET',
                headers: { "Content-Type": "application/json" },
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return {
                success: result.status || false,
                message: result.message || 'No description available',
                goalId: result.goalId,
                goalName: result.goalName
            };
        } catch (error) {
            console.error("Error get goals info:", error.message);

            return {
                success: false,
                message: 'Error Happened',
                goalId: null,
                goalName: null
            };
        }
    }

    camelCase(str) {
        return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
    }
}

export default ApiSender;  